import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import router from "../router";

import VueCookies from "vue-cookies";
Vue.use(VueCookies);
Vue.$cookies.config("7d");

import axios from "axios";
const instance = axios.create({
  baseURL: "https://polymerisapi.iranpolymer.com/api/",
  timeout: 60000,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json"
  }
});

const store = new Vuex.Store({
  state: {
    user: null,
    loading: false,
    error: null,
    message: null,
    messageState: false,
    messageType: null
  },
  mutations: {
    setUser: (state, payload) => {
      state.user = payload;
    },
    setLoading: (state, payload) => {
      state.loading = payload;
    },
    setError: (state, payload) => {
      state.error = payload;
    },
    setMessage: (state, payload) => {
      state.message = payload;
    },
    setMessageState: (state) => (state.messageState = true),
    setMessageType: (state, payload) => {
      state.messageType = payload;
    },
    clearUser: (state) => (state.user = null),
    clearError: (state) => (state.error = null),
    clearMessageState: (state) => (state.messageState = false)
  },
  actions: {
    signupUser: ({ commit }, payload) => {
      commit("clearError");
      commit("setLoading", true);
      instance
        .post("user/Register", payload)
        .then(({ data }) => {
          commit("setLoading", false);
          Vue.$cookies.set("jwt", data.token);
          commit("setUser", data.user);
          router.go();
        })
        .catch((err) => {
          commit("setLoading", false);
          commit("setError", err);
        });
    },
    signinUser: ({ commit }, payload) => {
      commit("clearError");
      commit("setLoading", true);
      instance
        .post("user/login", payload)
        .then(({ data }) => {
          const user = data.user;
          const token = data.token;
          Vue.$cookies.set("jwt", token);
          commit("setUser", user);
          router.go();
        })
        .catch((err) => {
          commit("setLoading", false);
          commit("setError", err.response.data.message);
        });
    },
    signoutUser: async ({ commit }) => {
      commit("setLoading", true);
      commit("clearError");
      Vue.$cookies.remove("jwt");
      commit("clearUser");
      commit("setLoading", false);
      const route = router.currentRoute.name;
      if (route == "Home") {
        router.go();
      } else {
        router.push({ name: "Home" });
      }
    },
    checkUser: async ({ commit }) => {
      commit("clearError");
      commit("setLoading", true);
      const token = Vue.$cookies.get("jwt");
      if (token) {
        instance
          .get("user/checkToken", {
            headers: {
              Authorization: token
            }
          })
          .then(({ data }) => {
            commit("setLoading", false);
            commit("setUser", data.user);
          })
          .catch(() => {
            Vue.$cookies.remove("jwt");
            commit("setLoading", false);
            commit("clearUser");
          });
      }
    }
  },
  getters: {
    user: (state) => state.user,
    loading: (state) => state.loading,
    error: (state) => state.error,
    message: (state) => state.message,
    messageState: (state) => state.messageState,
    messageType: (state) => state.messageType
  }
});

export default store;
